// request for lazy loading for all pages

export default class tableRequest {
  IsActive = true;
  PageNo = 1;
  First = 1;
  SearchValue = "";
  PageSize = 10;
  SortColumn = "";
  SortOrder = "DESC";
  ProductId = 0;
  WareHouseId = 0;
  UserId = 0;
  UserType = 0;
  FromDate = "";
  ToDate = "";
  IsAccepted = false;
  IsWareHouse = true;
  Prefix = "";
  isPreprinted = false;
  Qty = 0;
  Type = 0;
}
